
import {Component} from 'vue-property-decorator';
import AppIndexViewBase from './app-index-view-base.vue';
import {Environment} from "@/environments/environment";
import view_appmenu from '@widgets/app/app-index-view-appmenu/app-index-view-appmenu.vue';
import AppCenterService from "@service/app/app-center-service";

@Component({
  components: {
    view_appmenu,
  },
  beforeRouteEnter: (to: any, from: any, next: any) => {
    next((vm: any) => {
      if (!Object.is(vm.navModel, "route")) {
        vm.initNavDataWithTab(vm.viewCacheData);
      }
      vm.$store.commit('addCurPageViewtag', {fullPath: to.fullPath, viewtag: vm.viewtag});
    });
  },
})
export default class AppIndexView extends AppIndexViewBase {
  // TODO:获取坐席账号
  // agentId: any = '7996'
  // agentExt: any = '7998'
  callHtml: any = `https://softphone.jomoo.cn/SoftPhonePortal/softPhone?agentId=${this.agentId}&ext=${this.agentExt}`

  menuItems: any = []

  public mounted() {
    this.isRefresh = true
    window.addEventListener('load', (e: any) => {
      this.isRefresh = false
    })
    // @ts-ignore
    this.$super.init(AppIndexViewBase, 'mounted', [], this)
    if (sessionStorage.getItem("pwdExpiredTime")) {
      const expiredDay = sessionStorage.getItem("pwdExpiredTime");
      this.$Message.warning({
        content: `您的密码将在${expiredDay}天后失效,避免影响你的使用,请及时修改密码`,
        duration: 10,
        closable: true
      });
      sessionStorage.removeItem("pwdExpiredTime");
    }
    if (sessionStorage.getItem("changepassword")) {
      // @ts-ignore
      const user:any=JSON.parse(localStorage.getItem('user'))
      const loginName:any=user.loginName
      if(loginName[0]!=='F'){
          this.$Message.error({
              content: '您的密码已过期，请到OA修改密码。',
              duration: 5,
              closable: true
            });
          AppCenterService.notifyMessage({
            name: "isFirstLogin",
            action: 'changepassword',
            data: {'canClose': false, "modalVisible": true}
          })
        return
      }
      AppCenterService.notifyMessage({
        name: "isFirstLogin",
        action: 'changepassword',
        data: {'canClose': true, "modalVisible": true}
      })
    }
    if(this.agentId && this.agentExt){
      // @ts-ignore
      this.$softPhone.jsGetServersInfo(this.agentId, this.agentExt, this, this.$refs.iframe)
    }
    this.getLang()
  }
  public menuitemFlatten:any=[]//当前账号的菜单权限
  public menuAll:any=[]//所有菜单的数据
  public getMenuFlat(arr:any,target:any){
    arr.forEach((e:any)=>{
      if(e.path) {
        target.push(e.path)
      }else{
        this.getMenuFlat(e.items,target)
      }
    })
  }
  public afterCreated() {
    this.getAllMenu()
    // 获取tab页的国际化信息
    this.getLang()
    // @ts-ignore
    this.$super.init(AppIndexViewBase, 'afterCreated', [], this)
    this.$http.post('/runtime/runtimeapi/syspssystems/getAllMenu',{},false).then((res:any)=>{
      this.menuAll=[]
      this.getMenuFlat(res.data,this.menuAll)
      sessionStorage.setItem('menuDataAll',JSON.stringify(this.menuAll))
    })
  }
  private async getAllMenu() {
    const {data: menuData} = await this.getMenuItems()
    this.menuItems = (menuData || []).concat([])
    if(this.menuItems.length==0){
      // @ts-ignore
      this.$refs.appUser.logout()
      alert('您的账号已被冻结，请联系管理员!')
      return
    }
    this.menuitemFlatten=[]
    this.getMenuFlat(this.menuItems,this.menuitemFlatten)
    sessionStorage.setItem('menuDataByRole',JSON.stringify(this.menuitemFlatten))
  }
  public searchkey:any = null
  public timeout:any = null
  public searchRoute(key:any) {
    let _this = this
    clearTimeout(this.timeout);
      // 设置新的定时器
      this.timeout = setTimeout(() => {
        // 在这里执行实际的操作
       //@ts-ignore
      _this.$http.get(`/runtimeapi/syspssystems/menuByRole?keyword=${key}`,false).then((res: any) => {
        _this.menuItems = (res.data || []).concat([])
        //@ts-ignore
        _this.$refs.appmenu.defaultOpeneds = []
        let arr = _this.flattenData(res.data)
        let arr2 = _this.flattenTree(res.data)
        arr.forEach((item:any) => {
          item.ishave = false
            if (key != null && key != '') {
              item.items.forEach((item2:any) => {
                if (item2.label.includes(key)) {
                  item.ishave = true
                }
              })
             arr2.forEach((item3:any) => {
              if (item3.ishave == true) {
                if (item3.parent != null) {
                item3.parent.ishave = true
                }
              }
             })
             if (item.ishave) {
                 //@ts-ignore
              _this.$refs.appmenu.defaultOpeneds.push(item.label)
              }
            }
        })
        //  console.log('arr', arr)
        //  console.log('_this.$refs.appmenu.defaultOpeneds', _this.$refs.appmenu.defaultOpeneds)
           //@ts-ignore
        _this.$refs.appmenu.defaultOpeneds.forEach((item:any) => {
          arr.forEach((item2:any) => {
              if (item2.parent != null) {
                if (item2.parent.ishave) {
                   //@ts-ignore
                 _this.$refs.appmenu.defaultOpeneds.push(item2.parent.label)
                }
              } else if (item2.parent == null) {
                if (item2.ishave) {
                   //@ts-ignore
                _this.$refs.appmenu.defaultOpeneds.push(item2.label)
                //  console.log('_this.$refs.appmenu.defaultOpeneds', _this.$refs.appmenu.defaultOpeneds)
                }
              }
          })
        })
         //@ts-ignore
         _this.$refs.appmenu.defaultOpeneds = Array.from(new Set(_this.$refs.appmenu.defaultOpeneds))
      })


      }, 300);
    // setTimeout(() => {

    // },500)
  }
   //@ts-ignore
  public flattenTree(tree, parent = null) {
    //@ts-ignore
  let flattened = [];
   //@ts-ignore
  tree.forEach(node => {
    node.parent = parent; // 保存父节点
     //@ts-ignore
    flattened.push(node);
    if (node.items && node.items.length) {
      // 递归处理子节点
       //@ts-ignore
      flattened = flattened.concat(this.flattenTree(node.items, node));
    }
  });
   //@ts-ignore
  return flattened;
}
 public flattenData(data:any, result = []) {
  data.forEach((item:any) => {
    //@ts-ignore
    result.push(item);
    if (item.items && item.items.length > 0) {
      this.flattenData(item.items, result);
    }
  });
  return result;
}

  private async getMenuItems() {
    return await this.$http.get('/runtimeapi/syspssystems/menuByRole', false)
  }

  getLang() {
    // const keys: any = ['woLang']
    // const method: any = ['WorkOrder']
    const keys: any = ['bdLang', 'woLang', 'spLang', 'rtLang','reLang']
    const method: any = ['BasicData', 'WorkOrder', 'SpareParts', 'Runtime',"Reports"]

   keys.forEach((key: any, idx: any) => {
      const lang: any = JSON.parse(sessionStorage.getItem(key) || '{}')
      const hasPropery: any = Object.keys(lang).length
      hasPropery && this.$i18n.mergeLocaleMessage('zh-CN', lang)
      !hasPropery && (this as any)['get' + method[idx] + 'Lang']()
    })
  }

  getBasicDataLang() {
    // const prefix:any = 'cssbasicdata'

    const prefix: any = (Environment as any).BasicDataUrl.replace(/\/#\/*/, '')
    this.$http.get(`${prefix}/assets/json/zh-CN.ts`).then((res: any) => {
      const message: any = eval('(' + res.data.replace('const data: any = ', '') + ')')
      this.$i18n.mergeLocaleMessage('zh-CN', message)
      sessionStorage.setItem('bdLang', JSON.stringify(message))
    })
  }
  getReportsLang() {
    // const prefix:any = 'cssreports'

    const prefix: any = (Environment as any).ReportUrl.replace(/\/#\/*/, '')
    this.$http.get(`${prefix}/assets/json/zh-CN.ts`).then((res: any) => {
      const message: any = eval('(' + res.data.replace('const data: any = ', '') + ')')
      this.$i18n.mergeLocaleMessage('zh-CN', message)
      sessionStorage.setItem('reLang', JSON.stringify(message))
    })
  }

  getWorkOrderLang() {
    const prefix: any = (Environment as any).WkdUrl.replace(/\/#\/*/, '')
    // const prefix:any = 'cssworkorder'
    this.$http.get(`${prefix}/assets/json/zh-CN.ts`).then((res: any) => {
      const message: any = eval('(' + res.data.replace('const data: any = ', '') + ')')
      this.$i18n.mergeLocaleMessage('zh-CN', message)
      sessionStorage.setItem('woLang', JSON.stringify(message))
    })
  }

  getSparePartsLang() {
    const prefix: any = (Environment as any).SparePartsUrl.replace(/\/#\/*/, '')
    // const prefix:any = 'cssspareparts'
    this.$http.get(`${prefix}/assets/json/zh-CN.ts`).then((res: any) => {
      const message: any = eval('(' + res.data.replace('const data: any = ', '') + ')')
      this.$i18n.mergeLocaleMessage('zh-CN', message)
      sessionStorage.setItem('spLang', JSON.stringify(message))
    })
  }

  getRuntimeLang() {
    const prefix: any = (Environment as any).RuntimeUrl.replace(/\/#\/*/, '')
    this.$http.get(`${prefix}/assets/json/zh-CN.ts`).then((res: any) => {
      const message: any = eval('(' + res.data.replace('const data: any = ', '') + ')')
      this.$i18n.mergeLocaleMessage('zh-CN', message)
      sessionStorage.setItem('rtLang', JSON.stringify(message))
    })
  }

}
